import type {
  Middleware
} from 'redux';
import {
  welcomeOfferSlice,
  setWelcomeOfferTimerId,
  type WelcomeOfferState
} from '../model';

export const handleClearWelcomeOfferTimeoutMiddleware: Middleware = ({ dispatch, getState }) => next => (action: unknown) => {
  const state = getState() as unknown as { [welcomeOfferSlice.name]: WelcomeOfferState };

  const timerId = state[welcomeOfferSlice.name].timerId;

  const isSignedIn = (action as { type: string }).type === 'session/setSignedInData';
  const isSigningUp = (action as { meta: { arg: { endpointName: string } } })?.meta?.arg?.endpointName === 'quickSignUp';

  if (isSignedIn || isSigningUp) {
    if (timerId) {
      clearTimeout(timerId);
      dispatch(setWelcomeOfferTimerId(null));
    }
  }

  return next(action);
};